import { getIn } from "final-form"
import React, { useEffect, useRef } from "react"
import { FormSpy, useForm } from "react-final-form"

const hasFieldValue = (value) => {
  if (value === null || value === undefined) {
    return false
  }

  if (typeof value === "string") {
    return value.trim() !== ""
  }

  if (typeof value === "number" || typeof value === "boolean") {
    return true
  }

  if (Array.isArray(value)) {
    return value.length > 0
  }

  if (typeof value === "object") {
    if (value.value !== undefined && value.value !== null && value.value !== "") {
      return true
    }

    if (value.label !== undefined && value.label !== null && String(value.label).trim() !== "") {
      return true
    }

    return false
  }

  return true
}

const collectErrorFieldPaths = (errors, prefix = "") => {
  if (!errors || typeof errors !== "object") {
    return []
  }

  return Object.entries(errors).flatMap(([key, value]) => {
    const path = prefix ? `${prefix}.${key}` : key

    if (typeof value === "string") {
      return [path]
    }

    if (Array.isArray(value)) {
      return value.flatMap((item, index) => collectErrorFieldPaths(item, `${path}[${index}]`))
    }

    if (value && typeof value === "object") {
      return collectErrorFieldPaths(value, path)
    }

    return []
  })
}

function TouchInitialInvalidFieldsInner({ errors, validating }) {
  const form = useForm()
  const hasValidatedRef = useRef(false)
  const hasTouchedRef = useRef(false)

  useEffect(() => {
    if (hasTouchedRef.current) {
      return
    }

    if (validating) {
      hasValidatedRef.current = true
      return
    }

    if (!hasValidatedRef.current) {
      return
    }

    hasTouchedRef.current = true
    const values = form.getState().values

    try {
      collectErrorFieldPaths(errors)
        .filter((path) => hasFieldValue(getIn(values, path)))
        .forEach((path) => form.blur(path))
    } catch (error) {
      console.warn("TouchInitialInvalidFields:", error)
    }
  }, [errors, validating, form])

  return null
}

export default function TouchInitialInvalidFields() {
  return (
    <FormSpy subscription={{ errors: true, validating: true }}>
      {({ errors, validating }) => (
        <TouchInitialInvalidFieldsInner errors={errors} validating={validating} />
      )}
    </FormSpy>
  )
}
